export const LOCALE_PREFIX = 'components.Dialog.components.ReportOwnershipConfirm'
